import { InfoCircleFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'
import type React from 'react'

type InfoIconProps = {
  tooltipTitle: React.ReactNode
} & React.ComponentProps<typeof InfoCircleFilled>

export function InfoIcon({ tooltipTitle, style, ...iconProps }: InfoIconProps) {
  return (
    <Tooltip trigger='hover' title={tooltipTitle}>
      <InfoCircleFilled style={{ fontSize: '12px', ...style }} {...iconProps} />
    </Tooltip>
  )
}
